var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
const SALES_PIPELINE_ID = "default";
// Sales Pipeline stages in the order the queue shows them: furthest along first, closed deals last.
// The IDs come from HubSpot (Settings → Objects → Deals → Pipelines → Sales Pipeline).
const SALES_PIPELINE_STAGES = [
    { id: "3212992724", label: "Trial" },
    { id: "3734927608", label: "Negotiation" },
    { id: "qualifiedtobuy", label: "Meetings" },
    { id: "6292828346", label: "Needs Attention" },
    { id: "245556182", label: "Positive Reply" },
    { id: "closedwon", label: "Closed won" },
    { id: "closedlost", label: "Closed lost" },
];
const OTHER_STAGE_SECTION = { key: "other-stage", label: "Other" };
const OTHER_PIPELINES_SECTION = { key: "other-pipelines", label: "Other pipelines" };
const getDealStageId = (deal) => String(deal.dealstage || deal.stage || "");
const isInSalesPipeline = (deal) => !deal.pipeline || deal.pipeline === SALES_PIPELINE_ID;
/**
 * The stage's name for Sales Pipeline deals; other pipelines and unknown stages keep the HubSpot stage ID
 */
export const getDealStageLabel = (deal) => {
    var _a;
    const stageId = getDealStageId(deal);
    if (!isInSalesPipeline(deal))
        return stageId || "Unknown";
    return ((_a = SALES_PIPELINE_STAGES.find((stage) => stage.id === stageId)) === null || _a === void 0 ? void 0 : _a.label) || stageId || "Unknown";
};
const getSectionFor = (deal) => {
    if (!isInSalesPipeline(deal))
        return Object.assign(Object.assign({}, OTHER_PIPELINES_SECTION), { rank: SALES_PIPELINE_STAGES.length + 1 });
    const stageId = getDealStageId(deal);
    const rank = SALES_PIPELINE_STAGES.findIndex((stage) => stage.id === stageId);
    if (rank === -1)
        return Object.assign(Object.assign({}, OTHER_STAGE_SECTION), { rank: SALES_PIPELINE_STAGES.length });
    return { key: stageId, label: SALES_PIPELINE_STAGES[rank].label, rank };
};
/**
 * Groups deals into one section per stage, furthest along in the Sales Pipeline first; deals keep their order within
 * a section, and empty sections are left out
 */
export const groupDealsByStage = (deals) => {
    var _a;
    const sectionsByKey = new Map();
    for (const dealWithTracker of deals) {
        const { key, label, rank } = getSectionFor(dealWithTracker.deal);
        const section = (_a = sectionsByKey.get(key)) !== null && _a !== void 0 ? _a : { key, label, rank, deals: [] };
        section.deals.push(dealWithTracker);
        sectionsByKey.set(key, section);
    }
    return [...sectionsByKey.values()].sort((a, b) => a.rank - b.rank).map((_a) => {
        var { rank: _rank } = _a, section = __rest(_a, ["rank"]);
        return section;
    });
};
